import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

// const getAgentDashboard = (id, query, searchBy) => {
//   return Api(
//     `${endPoints.getAgentDashboard}/${id}?startDate=${query.startDate}&endDate=${query.endDate}&searchBy=${searchBy}`,
//     id,
//     requestType.GET
//   );
// };

const getAgentDashboard = (id, query, searchBy) => {
  const url = `${endPoints.getAgentDashboard}/${id}`;
  const queryParams = new URLSearchParams();

  if (query.startDate) {
    queryParams.append("startDate", query.startDate);
  }
  if (query.endDate) {
    queryParams.append("endDate", query.endDate);
  }

  if (query.pricingMode) {
    queryParams.append("pricingMode", query.pricingMode);
  }
  if (searchBy) {
    queryParams.append("searchBy", searchBy);
  }
  if (query.upgradeContract) {
    queryParams.append("upgradeContract", query.upgradeContract);
  }
  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;

  return Api(finalUrl, id, requestType.GET);
};

// const getAdminDashboard = (id, query, searchBy) => {
//   return Api(
//     `${endPoints.getAdminDashboard}?startDate=${query.startDate}&endDate=${query.endDate}&searchBy=${searchBy}`,
//     { id },
//     requestType.POST,
//   );
// };

const getAdminDashboard = (id, query, searchBy) => {
  const url = endPoints.getAdminDashboard;
  const queryParams = new URLSearchParams();

  if (query.startDate) {
    queryParams.append("startDate", query.startDate);
  }
  if (query.endDate) {
    queryParams.append("endDate", query.endDate);
  }
  if (query.pricingMode) {
    queryParams.append("pricingMode", query.pricingMode);
  }
  if (searchBy) {
    queryParams.append("searchBy", searchBy);
  }
  if (query.upgradeContract) {
    queryParams.append("upgradeContract", query.upgradeContract);
  }

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;

  return Api(finalUrl, { id }, requestType.POST);
};

const getDashboardContract = (id, query) => {
  return Api(
    `${endPoints.getDashboardContract}/${id}?startDate=${query.startDate}&endDate=${query.endDate}`,
    id,
    requestType.GET,
  );
};

export { getAgentDashboard, getAdminDashboard, getDashboardContract };
